import { ThunkResult } from '../../../store/configureStore'
import { getFileFilters } from '../../../store/reducers/fileList.reducer'
import { Actions } from '../available-file-listing/actionCreators'

export const setSearchFilter: (search: string) => ThunkResult<Promise<void>> =
  (search: string) => async (dispatch, getState) => {
    dispatch(Actions.searchFilterUpdated(search))
  }

